import type { TefComs4p } from '@mfe/components/TefComs4p';
import { consentStore } from '@mfe/store';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders the main compoennt view
//
export const tefComs4pView = function render(this: TefComs4p)
  : ReturnType<typeof html> {
  return html`
    <one-stack gap="sm">
      <one-content>
        <one-heading level="h4" variant="default">Partner-APP Einstellungen</one-heading>
        <one-text as="p">
          Im Folgenden können Sie für jede Partner-APP den Verarbeitungen personenbezogener Daten auf Grundlage gesetzlicher Bestimmungen widersprechen und Ihre ggf. erteilten Einwilligungen sehen. 
        </one-text>
        <one-text as="p">
          Nähere Informationen zu den Partner-Services und Verarbeitungszwecken finden Sie auf unserer Seite.
        </one-text>
        <one-text as="p">
          <a href="https://www.telefonica.de/unternehmen/datenschutz/partner-services.html">Partner Services I Telefonica Deutschland (telefonica.de)</a>
        </one-text>
        <one-spacer size="lg"></one-spacer>
        ${consentStore.actualConsents.map((purpose : Purpose) => this.getTemplateFn('singlePurposeView')(purpose))}

        <section class="section section-buttons">
          <div class="form-row">
            <tef-coms-back-button text="Zurück"></tef-coms-back-button>
          </div>
        </section>

      </one-content>
    </one-stack>
  `;
};
